export function getPosition(index) {
  return index + 1;
}

export function getFullName(compareciente) {
  let nombreCompleto = compareciente.denominacion_social;

  if (compareciente.persona.includes("Física")) {
    nombreCompleto = `${compareciente.nombre} ${compareciente.paterno} ${compareciente.materno || ""}`.trimEnd();
  }

  return nombreCompleto || "";
}
